<template>
  <span>
    <span v-if="choice.is_answer" class="text-success"><i class="fas fa-check-circle"></i></span>
    <span v-if="isWrongChoice" class="text-danger"><i class="fas fa-minus-circle"></i> <s>{{ choice.label }}</s> </span>
    <span v-if="!isWrongChoice">{{ choice.label }}</span>
  </span>
</template>

<script>
export default {
  props:{
    choice: {type: Object, required:true},
    answer: {type: Object, default: null}
  },
  computed:{
    isWrongChoice(){
      if(this.choice.is_answer ||  !this.answer){
        return false
      }

      return this.answer.choice_ids.indexOf(this.choice.id) >= 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/reports/response-detail/question-label.vue